export const ApiControllers = {
    registration:"Registration/",
    sample:'sample/',
    cardsManageservice:'CardsManageService/',
    CardsActivityService:'CardsActivityService/',
    Sass:"Sass/",
    caseManagement:"CaseManagement/",
    energy:"energy/",
}